import { IAssessment, IPeriod, IPosition, IPositionTrajectory } from './services/nextpeakClient';
import dayjs from 'dayjs';

export const isAssessmentFilledOutByUser = (assessment: IAssessment) => {
	const userResponse = assessment.assessmentResponses?.find((response) => response.userId === assessment.employeeUserId)
	return !!userResponse?.completedAt
}

export const getEmployeeResponse = (assessment: IAssessment) => {
	return assessment.assessmentResponses?.find((response) => response.userId === assessment.employeeUserId)
}

export const isAssessmentFilledOutByManager = (assessment: IAssessment) => {
	const managerResponse = assessment.assessmentResponses?.find((response) => response.userId === assessment.managerUserId)
	return !!managerResponse?.completedAt
}

export const getManagerResponse = (assessment: IAssessment) => {
	return assessment.assessmentResponses?.find((response) => response.userId === assessment.managerUserId)
}

export const transformPositionsArray = (positions: IPosition[]) => {
	// Step 1: Create a map to accumulate levels for each title
	const titleMap = new Map()

	// Step 2: Populate the map with levels for each title
	positions.forEach(({ level, role }) => {
		if (!titleMap.has(role)) {
			titleMap.set(role, [])
		}
		titleMap.get(role).push(level)
	})

	// Step 3: Convert the map into the desired output format
	return Array.from(titleMap, ([role, levels]) => ({
		role,
		levels,
	}))
}

export const getPositionByRoleAndLevel = (positions: IPosition[], role?: string, level?: string) => {
	if (!role || !level) return undefined
	return positions.find((position) => position.role === role && position.level === level)
}

interface ITrajectoryWithCompletion extends IPositionTrajectory {
	isCompleted: boolean
}

export const markTrajectoryStepAsCompleted = (items: IPositionTrajectory[], currentPositionId: string): ITrajectoryWithCompletion[] => {
	// Step 1: Sort the array by 'progressionOrder'
	items.sort((a, b) => a.progressionOrder! - b.progressionOrder!)

	const mapped: ITrajectoryWithCompletion[] = items.map((item) => ({ ...item, isCompleted: false }))

	// Step 2: Add 'isCompleted' property based on 'currentPositionId'
	let isCompleted = true
	for (let item of mapped) {
		if (isCompleted) {
			item.isCompleted = true
		} else {
			item.isCompleted = false
		}

		// If current item matches 'currentPositionId', set 'isCompleted' to false for remaining items
		if (item.fromPosition!.id === currentPositionId) {
			isCompleted = false
		}
	}

	return mapped
}

export const parseStringBoolean = (value: string | null): boolean => {
	if (value === 'true') return true
	if (value === 'false') return false
	return false
}

export const formatPeriodName = (period: IPeriod): string => {
  return `${dayjs(period.startsAt).format('YYYY/MM/DD')} - ${dayjs(period.endsAt).format('YYYY/MM/DD')}`
}
